import { __extends } from "tslib";
import WarehouseService from '@/modules/warehouses/WarehouseService';
import { BaseStockModel } from '@/core/standard/BaseStockModel';
var warehouse = {
  uuid: '',
  name: '',
  location: '',
  description: ''
};

var WarehouseModel =
/** @class */
function (_super) {
  __extends(WarehouseModel, _super);

  function WarehouseModel() {
    var _this = _super.call(this, warehouse, WarehouseService) || this;

    _this.modelName = 'Mesa';
    _this.request = 'FormData';
    return _this;
  }

  return WarehouseModel;
}(BaseStockModel);

export default WarehouseModel;